import { ReactElement, ReactNode } from 'react';

const Wallet = ({ visible, children, hide }: { visible: boolean; children?: ReactNode[] | ReactNode; hide: () => void }): ReactElement => {
    return <>{children}</>;
};
export default Wallet;
